module.exports = __webpack_public_path__ + "static/snow-crash-29d421ad154d6c624dbaf36d0c9959c5.jpg";